var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcInfo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.998 5.838c-5.612 0-10.162 4.55-10.162 10.162s4.55 10.162 10.162 10.162S26.16 21.612 26.16 16 21.61 5.838 15.998 5.838M4.16 16c0-6.538 5.3-11.838 11.838-11.838S27.836 9.462 27.836 16s-5.3 11.838-11.838 11.838S4.16 22.538 4.16 16m11.838 5.225a.85.85 0 0 1-.85-.85v-5.25a.85.85 0 0 1 1.7 0v5.25c0 .47-.38.85-.85.85m1-9.95a1 1 0 0 1-2 0v-.088a1 1 0 1 1 2 0z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcInfo);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };